<template>
  <section class="about reveal-section" id="nosotros" ref="sectionRef">
    <div class="section-header">
      <span class="section-label">Nuestra Esencia</span>
      <h2 class="section-title">¿Quiénes Somos?</h2>
      <p class="section-subtitle">Un movimiento apasionado de profesionales cristianos dedicados a equipar a la próxima generación</p>
    </div>
    <div class="about-grid">
      <div class="about-content">
        <p class="about-text">
          Somos un movimiento apasionado de profesionales y creyentes dedicados a equipar a la próxima generación.
          En Vision House, fusionamos diversos dones, talentos y disciplinas con principios bíblicos para capacitar
          a iglesias, institutos y organizaciones.
          <br><br>
          Nuestra razón de ser es movilizar a la niñez y juventud hacia el cumplimiento de la Gran Comisión,
          enfocándonos en un modelo de crecimiento sostenible y multiplicación.
        </p>
        <div class="about-stats">
          <div class="stat-item">
            <span class="stat-number" data-target="500">0</span>
            <span class="stat-label">Jóvenes Impactados</span>
          </div>
          <div class="stat-item">
            <span class="stat-number" data-target="12">0</span>
            <span class="stat-label">Comunidades</span>
          </div>
          <div class="stat-item">
            <span class="stat-number" data-target="8">0</span>
            <span class="stat-label">Años de Servicio</span>
          </div>
        </div>
      </div>
      <div class="about-image">
        <img src="/team.webp" alt="Equipo Vision House sirviendo en comunidad">
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useScrollReveal } from '@/composables/useAnimations'

const sectionRef = ref<HTMLElement | null>(null)
const { registerReveal } = useScrollReveal()

onMounted(() => registerReveal(sectionRef.value))
</script>

<style scoped>
.about { background: var(--vh-blanco); overflow: hidden; padding: 7rem 5%; }
.about-grid {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: 5rem; align-items: center; max-width: 1200px; margin: 0 auto;
}
.about-text { font-size: 1.15rem; line-height: 2; color: #444; margin-bottom: 2.5rem; }
.about-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem; }
.stat-item {
  text-align: center; padding: 1.8rem 1rem;
  background: var(--vh-gris-piedra); border-radius: 20px;
  transition: var(--vh-transicion); position: relative; overflow: hidden;
}
.stat-item::before {
  content: ''; position: absolute; top: 0; left: 0;
  width: 100%; height: 4px;
  background: linear-gradient(90deg, var(--vh-azul-profundo), var(--vh-dorado));
  transform: scaleX(0); transform-origin: left;
  transition: transform 0.4s ease;
}
.stat-item:hover::before { transform: scaleX(1); }
.stat-item:hover { transform: translateY(-8px); box-shadow: 0 15px 40px var(--vh-sombra); }
.stat-number {
  font-family: 'League Spartan', sans-serif;
  font-size: 2.5rem; font-weight: 800; color: var(--vh-azul-profundo);
  display: block; line-height: 1; margin-bottom: 0.5rem;
}
.stat-item:hover .stat-number { color: var(--vh-dorado); }
.stat-label { font-size: 0.85rem; font-weight: 700; color: #666; text-transform: uppercase; letter-spacing: 1px; }
.about-image { position: relative; }
.about-image img {
  width: 100%; border-radius: 24px;
  box-shadow: 0 25px 70px var(--vh-sombra);
  position: relative; z-index: 1; transition: var(--vh-transicion);
}
.about-image:hover img { transform: scale(1.02); }
.about-image::before {
  content: ''; position: absolute; top: -25px; right: -25px;
  width: 100%; height: 100%; border: 3px solid var(--vh-dorado);
  border-radius: 24px; z-index: 0; transition: var(--vh-transicion);
}
.about-image:hover::before { top: -15px; right: -15px; }
.about-image::after {
  content: ''; position: absolute; bottom: -40px; left: -40px;
  width: 150px; height: 150px;
  background: radial-gradient(circle, var(--vh-dorado) 2px, transparent 2px);
  background-size: 20px 20px; z-index: 2; opacity: 0.4;
}

@media (max-width: 1024px) {
  .about-grid { grid-template-columns: 1fr; gap: 3rem; }
}
@media (max-width: 768px) {
  .about-stats { grid-template-columns: 1fr; }
}
</style>
